var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3404A"
    },
    d: "M380.283,512H131.719c-8.123,0-14.708-6.586-14.708-14.708V380.023 c0-76.639,62.351-138.99,138.99-138.99c8.122,0,14.708,6.586,14.708,14.708c0,8.122-6.586,14.708-14.708,14.708 c-60.42,0-109.574,49.155-109.574,109.574v102.561h219.148V380.023c0-23.684-7.43-46.223-21.487-65.181 c-4.837-6.526-3.47-15.737,3.055-20.575c6.524-4.839,15.738-3.47,20.575,3.055c17.842,24.065,27.273,52.663,27.273,82.701v117.269 C394.991,505.415,388.405,512,380.283,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3404A"
    },
    d: "M404.729,512H107.271c-8.123,0-14.708-6.586-14.708-14.708s6.585-14.708,14.708-14.708h297.458 c8.122,0,14.708,6.586,14.708,14.708S412.851,512,404.729,512z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4B2B0"
    },
    d: "M256.001,256.26L256.001,256.26c68.639,0,124.282-55.643,124.282-124.282V14.708H131.719v117.269 C131.719,200.616,187.362,256.26,256.001,256.26z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3404A"
    },
    d: "M256.001,270.968c-76.639,0-138.99-62.351-138.99-138.99V14.708C117.011,6.586,123.595,0,131.719,0 h248.564c8.122,0,14.708,6.586,14.708,14.708v117.269C394.991,208.618,332.639,270.968,256.001,270.968z M146.426,29.416v102.561 c0,60.419,49.154,109.574,109.574,109.574c60.419,0,109.574-49.155,109.574-109.574V29.416H146.426z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3404A"
    },
    d: "M404.729,29.416H107.271c-8.123,0-14.708-6.586-14.708-14.708S99.148,0,107.271,0h297.458 c8.122,0,14.708,6.586,14.708,14.708S412.851,29.416,404.729,29.416z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3404A"
    },
    d: "M256.001,361.82c-8.123,0-14.708-6.586-14.708-14.708V255.74c0-8.122,6.585-14.708,14.708-14.708 c8.122,0,14.708,6.586,14.708,14.708v91.372C270.709,355.234,264.122,361.82,256.001,361.82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3404A"
    },
    d: "M207.464,89.065H134.66c-8.123,0-14.708-6.586-14.708-14.708s6.585-14.708,14.708-14.708h72.804 c8.123,0,14.708,6.586,14.708,14.708S215.588,89.065,207.464,89.065z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3404A"
    },
    d: "M380.651,452.352h-72.804c-8.122,0-14.708-6.586-14.708-14.708s6.586-14.708,14.708-14.708h72.804 c8.122,0,14.708,6.586,14.708,14.708S388.772,452.352,380.651,452.352z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.952bc0332bd3daeefb2225cb4e56d6d7.svg";
export { ForwardRef as ReactComponent };